import { Injectable, Optional } from '@angular/core';
import { RemoteService } from './remote.service';
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { LoggingService } from './logging/logging.service';
import { GenericService } from './generic.service';
import { AppUtility } from '../utils/utility';
import { Subscription } from 'rxjs';
@Injectable()
export class BrandingService {
    AF_ENABLEDflag: boolean;

    /* istanbul ignore next */
    constructor(
        private remoteService: RemoteService,
        private domStorageService: DomStorageFallbackService,
        private genericService: GenericService,
        @Optional() private appUtility: AppUtility) { }

    /**
      * Method to get Branding Url for AF and add it in SessionStorage
      */
    /* istanbul ignore next */
    public getSiteBrandingUrl() {
        let brandingObj = JSON.parse(this.domStorageService.getItem('brandingObj'));
        if (brandingObj &&  brandingObj.siteBrand && !this.isBrandingCheckRequiredPostAuth()) {
            if (Object.keys(brandingObj.siteBrand).length > 0) {
                this.appUtility.setBrandingStyle();
            }
        } else {
            let brandingState = this.domStorageService.getItem('isBrandingUpdated');
            if (brandingState === 'INITIATED') {
                return null;
            }

            if (this.isBrandingCheckRequiredPostAuth()) {
                this.domStorageService.setItem('isBrandingUpdated', 'INITIATED');
            }
            let brandingUrl = 'channel/widgetconfigurations/channel/widgetConfigurations/branding';
            let clientId = JSON.parse(this.domStorageService.getItem('alightRequestHeader')).clientId;
            if (clientId) {
                let lineage = clientId.toString();
                let requestObj = null;
                /* istanbul ignore next */
                if (this.appUtility.isPreAuth()) {
                    brandingUrl = 'channel/widgetconfigurations/channel/widgetConfigurations/branding/public';
                    if (LoggingService.uConsole) {
                        console.log('AppComponent : Inside Pre-Auth Case with brandingUrl :' + brandingUrl + ' Lineage : ' + lineage);
                    }
                    this.AF_ENABLEDflag = this.appUtility.isAfEnabled();
                    requestObj = this.createRequestJson(this.AF_ENABLEDflag);
                    if (LoggingService.uConsole) {
                        console.log('created requestObj for branding service with value' + requestObj);
                    }
                }
                return this.remoteService.request('get', {
                    restOfUrl: '',
                    endPoint: brandingUrl, isSecure: true, contentType: 'application/json',
                    customHeader: this.populateRequestHeader(requestObj)
                }).subscribe((response: Response) => {
                    let isBrandingLoaded = false;
                    if (response[0] != null) {
                        if (response[0].siteBrand) {
                            if (Object.keys(response[0].siteBrand).length > 0) {
                                this.domStorageService.setItem('brandingObj', JSON.stringify(response[0]), '', true);
                                if (this.isBrandingCheckRequiredPostAuth()) {
                                    this.domStorageService.setItem('isBrandingUpdated', 'UPDATED');
                                }
                                if (response[0].siteBrand.css) {
                                    if (response[0].siteBrand.css.themeURL) {
                                        const returnResp = this.genericService.getUpointNextUrl() + response[0].siteBrand.css.themeURL;
                                        this.domStorageService.setItem('upointNextURL', returnResp, '', true);
                                        if (returnResp) {
                                            this.appUtility.setBrandingStyle();
                                            isBrandingLoaded = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (!isBrandingLoaded) {
                        this.appUtility.loadUIRefresh();
                    }
                },
                    (error) => {
                        this.domStorageService.removeItem('isBrandingUpdated');
                        if (LoggingService.uConsole) {
                            console.log('AppComponent : Error while getting Branding URL  :' + error);
                        }
                    });
            }
        }
    }

    /* istanbul ignore next */
    public createRequestJson(
        af_switch_enabled?: boolean): Object {
        let parent = {};
        if (af_switch_enabled) {
            parent['AF_ENABLED'] = 'true';
        } else {
            parent['AF_ENABLED'] = 'false';
        }
        return parent;
    }

    /* istanbul ignore next */
    private populateRequestHeader(body: Object = {}): any {
        const requestArray = new Array();
        try {
            if (body) {
                for (const key of Object.keys(body)) {
                    const item = {};
                    item['key'] = key;
                    item['value'] = body[key];
                    requestArray.push(item);
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Brand Service : populateRequestHeader : requestArray ' + error);
            }
        }
        return requestArray;
    }

    /* istanbul ignore next */
    private isBrandingCheckRequiredPostAuth(): boolean {
        if (this.appUtility.isPreAuth()) {
            return false;
        }
        const serviceClients = JSON.parse(this.domStorageService.getItem('serviceClients'));
        const isPostAuthBrandingRequired = serviceClients && serviceClients['clientsetup'] && serviceClients['clientsetup']['branding.postAuth'];
        const isBrandingUpdated = this.domStorageService.getItem('isBrandingUpdated') || 'NA';
        if (LoggingService.uConsole) {
            console.log(`Brand Service : isBrandingCheckRequiredPostAuth : branding.postAuth
             ${isPostAuthBrandingRequired}  :isBrandingUpdated : ${isBrandingUpdated} :gaJson: ${JSON.parse(this.domStorageService.getItem('ga_json'))}`);
        }
        if (isPostAuthBrandingRequired !== undefined && isPostAuthBrandingRequired !== null && isPostAuthBrandingRequired !== '') {
            return (isPostAuthBrandingRequired && isBrandingUpdated !== 'UPDATED');
        } else {
            const gaJson = JSON.parse(this.domStorageService.getItem('ga_json'));
            const isPostAuthBrandingPartParam = gaJson && gaJson.param && gaJson.param.IS_POST_AUTH_BRANDING && gaJson.param.IS_POST_AUTH_BRANDING.val || false;
            return (isPostAuthBrandingPartParam && isBrandingUpdated !== 'UPDATED');
        }
    }
}

